import {navigationGuard} from './navigationGuard';

export default [
    {
        path: '/panel',
        name: 'Panel',
        component: () => import(/* webpackChunkName: "PanelView" */ '../PanelView.vue'),
        children: [
            {
                path: 'vouchers',
                name: 'Vouchers',
                component: () => import(/* webpackChunkName: "Vouchers" */ '../views/Vouchers.vue'),
                children: [
                    {
                        path: 'details/:voucherId',
                        name: 'VoucherDetails',
                        component: () => import(/* webpackChunkName: "VoucherDetails" */ '../components/Vouchers/VoucherDetails.vue'),
                        children: [
                            {
                                path: 'realization/:voucherId',
                                name: 'AddRealizationFromDetails',
                                component: () => import(/* webpackChunkName: "AddRealizationFromDetails" */ '../components/Vouchers/AddRealization.vue'),
                            },
                            {
                                path: 'edit/:voucherId',
                                name: 'EditVoucherFromDetails',
                                component: () => import(/* webpackChunkName: "EditVoucherFromDetails" */ '../components/Vouchers/EditVoucher.vue'),
                            },
                            {
                                path: 'edit/expiredAt/:voucherId',
                                name: 'EditExpiredAtFromDetails',
                                component: () => import(/* webpackChunkName: "EditExpiredAtFromDetails" */ '../components/Vouchers/EditExpiredAt.vue'),
                            },
                            {
                                path: 'edit/price/:voucherId',
                                name: 'EditPriceFromDetails',
                                component: () => import(/* webpackChunkName: "EditPriceFromDetails" */ '../components/Vouchers/EditPrice.vue'),
                            },
                        ],
                    },
                    {
                        path: 'create',
                        name: 'CreateVoucher',
                        component: () => import(/* webpackChunkName: "CreateVoucher" */ '../components/Vouchers/CreateVoucher.vue'),
                    },
                    {
                        path: 'realization/:voucherId',
                        name: 'AddRealization',
                        component: () => import(/* webpackChunkName: "AddRealization" */ '../components/Vouchers/AddRealization.vue'),
                    },
                    {
                        path: 'edit/:voucherId',
                        name: 'EditVoucher',
                        component: () => import(/* webpackChunkName: "EditVoucher" */ '../components/Vouchers/EditVoucher.vue'),
                    },
                    {
                        path: 'edit/expiredAt/:voucherId',
                        name: 'EditExpiredAt',
                        component: () => import(/* webpackChunkName: "EditExpiredAt" */ '../components/Vouchers/EditExpiredAt.vue'),
                    },
                    {
                        path: 'edit/price/:voucherId',
                        name: 'EditPrice',
                        component: () => import(/* webpackChunkName: "EditExpiredAt" */ '../components/Vouchers/EditPrice.vue'),
                    },
                ],
            },
            {
                path: 'users',
                name: 'Users',
                component: () => import(/* webpackChunkName: "Users" */ '../views/Users.vue'),
                beforeEnter: navigationGuard,
            },
            {
                path: 'tickets',
                name: 'Tickets',
                component: () => import(/* webpackChunkName: "Tickets" */ '../views/Tickets.vue'),
                children: [
                    {
                        path: 'create',
                        name: 'CreateTicket',
                        component: () => import(/* webpackChunkName: "CreateTicket" */ '../components/Tickets/CreateTicket.vue'),
                    },
                    {
                        path: 'edit/:ticketId',
                        name: 'EditTicket',
                        component: () => import(/* webpackChunkName: "EditTicket" */ '../components/Tickets/EditTicket.vue'),
                    },
                    {
                        path: 'details/:ticketId',
                        name: 'TicketDetails',
                        component: () => import(/* webpackChunkName: "VoucherDetails" */ '../components/Tickets/TicketDetails.vue'),
                        children: [
                            {
                                path: 'ticket_items/:ticketId',
                                name: 'AddRealizationTicketFromDetails',
                                component: () => import(/* webpackChunkName: "AddRealizationFromDetails" */ '../components/Tickets/AddRealization.vue'),
                            },
                            {
                                path: 'edit/:ticketId',
                                name: 'EditTicketFromDetails',
                                component: () => import(/* webpackChunkName: "EditVoucherFromDetails" */ '../components/Tickets/EditTicket.vue'),
                            },
                        ],
                    },
                    {
                        path: 'ticket_items/:ticketId',
                        name: 'AddRealizationTicket',
                        component: () => import(/* webpackChunkName: "AddRealization" */ '../components/Tickets/AddRealization.vue'),
                    },
                ],
            },
            {
                path: 'voucher-types',
                name: 'VoucherTypes',
                component: () => import(/* webpackChunkName: "VoucherTypes" */ '../views/VoucherTypes.vue'),
                beforeEnter: navigationGuard,
            },
            {
                path: 'debit-notes',
                name: 'DebitNotes',
                component: () => import(/* webpackChunkName: "DebitNotes" */ '../views/DebitNotes.vue'),
                children: [
                    {
                        path: 'create',
                        name: 'CreateDebitNote',
                        component: () => import(/* webpackChunkName: "CreateDebitNote" */ '../components/DebitNotes/CreateDebitNote.vue'),
                    },
                    {
                        path: 'edit/:noteId',
                        name: 'EditDebitNote',
                        component: () => import(/* webpackChunkName: "EditDebitNote" */ '../components/DebitNotes/EditDebitNote.vue'),
                    },
                    {
                        path: 'details/:noteId',
                        name: 'DebitNoteDetails',
                        component: () => import(/* webpackChunkName: "DebitNoteDetails" */ '../components/DebitNotes/DebitNoteDetails.vue'),
                    },
                ],
            },
        ],
    },
];
